import { useEffect } from 'react';
import PropTypes from 'prop-types';

import themePropTypes from 'core/utils/prop-types/theme';

import withTheme from 'core/hocs/withTheme';
import withBreakpoint from 'core/hocs/withBreakpoint';

/**
 * Стилизация для erratum взята из исходников
 * /node_modules/erratum/core/app.styl
 *
 * Данные стили явно никак не используются.
 * Необходимы для подгрузки как :global стили, в ассеты main.*.css
 */
import './index.styl';

const BUTTON_TYPE = 'primary';
const BUTTON_SIZE = 'medium';


function Erratum(props, context) {
  const {
    isDesktop,
    theme: {
      animations: {
        hover: hoverAnimation,
      },
      controls: {
        button: buttonAtoms,
        button: {
          const: {
            sizes: {
              [BUTTON_SIZE]: sizeAtoms,
            },
          },
          [BUTTON_TYPE]: typeAtoms,
        },
      },
    },
  } = props;

  const {
    erratumUrl,
  } = context;

  useEffect(() => {
    if (isDesktop) {
      const erratum = require('erratum');

      erratum({
        targetUrl: `${erratumUrl}`,
      });
    }
  }, [isDesktop, erratumUrl]);

  if (!isDesktop) return null;
  return (
    <style jsx global>{`
      .erratum-popup
        &_btn
          font ${sizeAtoms.font}
          min-width ${sizeAtoms.width}
          min-height ${sizeAtoms.height}
          padding ${sizeAtoms.padding}
          border-radius ${buttonAtoms.const.radius}
          color ${typeAtoms.idle.color}
          border ${typeAtoms.idle.border}
          background ${typeAtoms.idle.background}
          transition ${ ['color', 'border', 'background'].map(name => name + ' ' + hoverAnimation)}
          &:hover
            color ${typeAtoms.hover.color}
            border ${typeAtoms.hover.border}
            background ${typeAtoms.hover.background}
          &:active
            color ${typeAtoms.active.color}
            border ${typeAtoms.active.border}
            background ${typeAtoms.active.background}
    `}</style>
  );
}

const sizeContract = `
  {
    font,
    width,
    height,
    padding,
  }
`;

const stateContract = `
  {
    color,
    border,
    background,
  }
`;

const typeContract = `
  {
    idle: ${stateContract},
    hover: ${stateContract},
    active: ${stateContract},
    disabled: ${stateContract},
  }
`;

Erratum.contextTypes = {
  erratumUrl: PropTypes.string,
};

Erratum.propTypes = {
  /** @ignore */
  isDesktop: PropTypes.bool,
  /** @ignore */
  theme: themePropTypes(`{
    animations: {
      hover,
    },
    controls: {
      button: {
        const: {
          sizes: {
            small: ${sizeContract},
            medium: ${sizeContract},
            large: ${sizeContract},
          }
        },
        primary: ${typeContract},
        secondary: ${typeContract},
        ghost: ${typeContract},
      }
    },
  }`),
};

const ErratumWithHOCs = withTheme(withBreakpoint(Erratum));
ErratumWithHOCs.displayName = 'Erratum';

export { Erratum as StorybookComponent };
export default ErratumWithHOCs;
